import { login, getCaptchaUrl } from "@/api/system/user";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./login.css";
import { Card, Button, Checkbox, Form, Input, message, Space } from "antd";
import { encryptMD5UpperCase } from "@/utils/EncryptUtil";
import Iconfont from "@/components/Icon/IconFont";
const Login = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [captchaImg, setCaptchaImg] = useState("")

  useEffect(() => {
    getCaptchaImgUrl()
  }, [])

  const getCaptchaImgUrl = async () => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', getCaptchaUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (this.status === 200) {
        const blob = new Blob([this.response], { type: "image/jpeg" });
        let url = window.URL.createObjectURL(blob);
        setCaptchaImg(preUrl => url)
      }
    };
    xhr.send();
  }

  const onFinish = async (values) => {
    try {
      // MD5加密
      values.password = encryptMD5UpperCase(values.password);
      const response = await login(values);
      if (response.code === "0") {
        // 登录成功处理，重定向到主页，缓存token
        localStorage.setItem("userId", response.data.id);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userName", response.data.username);
        localStorage.setItem("realName", response.data.realName);
        localStorage.setItem("userType", response.data.userType);
        navigate("/")
      } else {
        getCaptchaImgUrl()
        messageApi.open({
          type: 'error',
          content: response.message,
        });
      }
    } catch (err) {
      console.log(err)
      messageApi.open({
        type: 'error',
        content: err,
      });
    }
  };
  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };
  return (
    <div className="login-page">
      {contextHolder}
      <Card
        title={
          <div style={{ padding: "8px" }}>
            <div className="login-title">登录</div>
            <a style={{ float: "right" }} onClick={() => {
              navigate("/register")
            }}>前往注册</a>
          </div>
        }
        variant="borderless"
        className="login-container"
      >
        <Form
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={null}
            name="username"
            rules={[{ required: true, message: "请输入用户名!", },]}
          >
            <Input placeholder="请输入用户名" allowClear prefix={<Iconfont icon="UserOutlined" />} />
          </Form.Item>
          <Form.Item
            label={null}
            name="password"
            rules={[{ required: true, message: "请输入密码!", },]}
          >
            <Input.Password placeholder="请输入密码" allowClear prefix={<Iconfont icon="FormOutlined" />} />
          </Form.Item>
          <Form.Item label={null} name="captcha" rules={[{ required: true, message: "请输入验证码!", }]} >
            <div style={{ display: "flex" }}>
              <Space>
                <Input placeholder="请输入验证码" allowClear />
                <img src={captchaImg} style={{ cursor: 'pointer' }} onClick={() => { getCaptchaImgUrl() }} />
              </Space>
            </div>
          </Form.Item>
          <Form.Item label={null}  >
            <Button type="primary" htmlType="Submit" className="login-submit">
              登录
            </Button>
          </Form.Item>
          <Form.Item
            name="remember"
            className="login-remeberme"
            valuePropName="checked"
            label={null}
          >
            <Checkbox>记住我</Checkbox>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
export default Login;
